/*
 * QUEST SOFTWARE PROPRIETARY INFORMATION
 *
 * This software is confidential.  Quest Software Inc., or one of its
 * subsidiaries, has supplied this software to you under terms of a
 * license agreement, nondisclosure agreement or both.
 *
 * You may not copy, disclose, or use this software except in accordance with
 * those terms.
 *
 *
 * Copyright 2026 Quest Software Inc.
 * ALL RIGHTS RESERVED.
 *
 * QUEST SOFTWARE INC. MAKES NO REPRESENTATIONS OR
 * WARRANTIES ABOUT THE SUITABILITY OF THE SOFTWARE,
 * EITHER EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED
 * TO THE IMPLIED WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE, OR
 * NON-INFRINGEMENT.  QUEST SOFTWARE SHALL NOT BE
 * LIABLE FOR ANY DAMAGES SUFFERED BY LICENSEE
 * AS A RESULT OF USING, MODIFYING OR DISTRIBUTING
 * THIS SOFTWARE OR ITS DERIVATIVES.
 */

import {
  Component,
  OnDestroy,
  OnInit,
  ChangeDetectionStrategy,
  Inject,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { isCloudFlagSelector } from 'src/app/store/app.selectors';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'fc-subscription-pending',
  templateUrl: './subscription-pending.component.html',
  styleUrls: ['./subscription-pending.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SubscriptionPendingComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  isCloudFlag!: boolean;
  theme!: string;
  instanceType!: string;
  monitorDomain!: string;
  constructor(
    private router: Router,
    private store: Store,
    public dialogRef: MatDialogRef<SubscriptionPendingComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: any
  ) {}

  ngOnInit(): void {
    this.theme = localStorage.getItem('theme') !== null ? localStorage.getItem('theme')! : 'light-theme';
    this.instanceType = this.data['instanceType'];
    this.monitorDomain = this.data['monitorDomain'];

    this.setCloudFlag();
  }
  
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  setCloudFlag(): void {
    this.store
      .select(isCloudFlagSelector)
      .pipe(takeUntil(this.destroy$))
      .subscribe((isCloud) => {
        this.isCloudFlag = isCloud;
      });
  }

  goToAccountSettings(): void {
    this.router.navigate(['/settings/account-settings']);
    this.closeDialog();
  }

  supportOnClick(): void {
    if (this.isCloudFlag) {
      window.open('https://support.quest.com/foglight-cloud');
    } else {
      window.open(
        `${environment.foglightBaseUrl}/console/page/system:administration_setupsupport_supportbundles.supportDashboard`
      );
    }

    this.closeDialog();
  }

  closeDialog(): void {
    this.dialogRef.close();
  }
}
